/**
 * Contact status flags (amendment 32 §5) — who has a channel switched off, or a
 * topic stopped. The Patients list filters *Contact › Texts off* and
 * *Contact › Stopped a topic* read this, and the General settings card's
 * *See who* lands on `/patients?contact=texts-off`.
 */
export type PtContactFilter = 'texts-off' | 'stopped-topic';

export interface PtContactFlag {
  id: string;
  name: string;
  phone: string;
  /** A channel switched off. */
  textsOff?: { since: string; how: string };
  /** A topic stopped, e.g. "aligners". */
  stoppedTopic?: { topic: string; since: string };
}

export const PT_CONTACT_FLAGS: PtContactFlag[] = [
  {
    id: 'leila-moradi', name: 'Leila Moradi', phone: '(210) 555-0184',
    textsOff: { since: '30 Sep', how: 'replied STOP to a reminder' },
  },
  {
    id: 'grace-whitfield', name: 'Grace Whitfield', phone: '(210) 555-0127',
    stoppedTopic: { topic: 'aligners', since: '12 Jun' },
  },
  {
    id: 'aaron-vasquez', name: 'Aaron Vasquez', phone: '(210) 555-0158',
    textsOff: { since: '24 Sep', how: 'asked the front desk' },
  },
];

export function ptContactMatches(filter: PtContactFilter): PtContactFlag[] {
  return PT_CONTACT_FLAGS.filter((p) => (filter === 'texts-off' ? p.textsOff !== undefined : p.stoppedTopic !== undefined));
}
